// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getProvinceRequest: ['data'],
  getProvinceSuccess: ['data'],
  getProvinceFailure: ['err'],

  getCityRequest: ['data'],
  getCitySuccess: ['data'],
  getCityFailure: ['err'],

  getDistrictRequest: ['data'],
  getDistrictSuccess: ['data'],
  getDistrictFailure: ['err'],
})

export const LocationTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  province: [],
  city: [],
  district: [],
  err: null,
  processing: false,
  success: null
})

/* ------------- Reducers ------------- */
// we're attempting to login
export const request = (state: Object) =>
  state.merge({ fetching: true, err: null })

// we've successfully logged in
export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null,
    success: null
  })

// we've had a problem logging in
export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null })

export const manipulateProvinceSuccess = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    processing: false,
    province: data,
    success: true,
    err: null
  })

export const manipulateCitySuccess = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    processing: false,
    city: data,
    success: true,
    err: null
  })

export const manipulateDistrictSuccess = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    processing: false,
    district: data,
    success: true,
    err: null
  })


export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_PROVINCE_SUCCESS]: manipulateProvinceSuccess,
  [Types.GET_PROVINCE_REQUEST]: request,
  [Types.GET_PROVINCE_FAILURE]: failure,

  [Types.GET_CITY_SUCCESS]: manipulateCitySuccess,
  [Types.GET_CITY_REQUEST]: request,
  [Types.GET_CITY_FAILURE]: failure,

  [Types.GET_DISTRICT_SUCCESS]: manipulateDistrictSuccess,
  [Types.GET_DISTRICT_REQUEST]: request,
  [Types.GET_DISTRICT_FAILURE]: failure,
})



// WEBPACK FOOTER //
// ./src/Redux/LocationRedux.js